(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("color-adjustments", [], factory);
	else if(typeof exports === 'object')
		exports["color-adjustments"] = factory();
	else
		root["color-adjustments"] = factory();
})(self, function() {
return 